import CohealerOneToOneDiscussion from './CohealerOneToOneDiscussionContainer';

export default CohealerOneToOneDiscussion;
